import { BsBox } from "react-icons/bs";
import { BsBox2 } from "react-icons/bs";
import { GrTransaction } from "react-icons/gr";
import { IoCardOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { CiCreditCard1 } from "react-icons/ci";
import { MdOutlineCreditCard } from "react-icons/md";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { LuScrollText } from "react-icons/lu";
import { BiBox } from "react-icons/bi";
import { FaRegCircleUser } from "react-icons/fa6";
import { LuHistory } from "react-icons/lu";
import { FaMoneyCheck } from "react-icons/fa6";

export const ADMIN_CONFIG = {
  code: 0,
  data: [
    {
      name: "TỔNG QUAN",
      path: "dashboard",
      icon: MdOutlineSpaceDashboard,
      componentName: "DashBoardPage",
      supplierCode: "DashBoardPage",
    },
    {
      name: "QUẢN LÝ ĐƠN HÀNG",
      path: "order",
      icon: BsBox,
      componentName: "",
      supplierCode: "OrderPage",
      subMenu: [
        {
          name: "Đăng ký thuê bao",
          path: "order/dkttb",
          componentName: "DKTTB",
          serviceCode: "dkttb",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng số đẹp",
          path: "order/premium-number",
          componentName: "PremiumNumber",
          serviceCode: "PremiumNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Chọn giữ số",
          path: "order/keep-number",
          componentName: "KeepNumber",
          serviceCode: "KeepNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Gán gói",
          path: "order/addPackage",
          componentName: "AddPackage",
          serviceCode: "addPackage",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Topup",
          path: "order/topup",
          componentName: "TopupOrder",
          serviceCode: "topup",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Data",
          path: "order/data",
          componentName: "DataOrder",
          serviceCode: "data",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn thương lượng",
          path: "order/negotiation",
          componentName: "NegotiationPage",
          serviceCode: "NegotiationPage",
          icon: GrTransaction,
          subMenu: [],
        },
      ],
    },
    {
      name: "QUẢN LÝ GIAO DỊCH",
      path: "transaction",
      icon: LuScrollText,
      componentName: "TransactionMer",
      supplierCode: "TransactionMer",
    },
    {
      name: "QUẢN LÝ HẠN MỨC",
      path: "wallet",
      icon: IoCardOutline,
      componentName: "LimitPage",
      supplierCode: "limit",
    },
    {
      name: "LỊCH SỬ DÒNG TIỀN",
      path: "history",
      icon: LuHistory,
      componentName: "Transaction",
      supplierCode: "history",
    },
    {
      name: "QUẢN LÝ SẢN PHẨM",
      path: "product",
      icon: BsBox2,
      componentName: "",
      supplierCode: "product",
      subMenu: [
        {
          name: "Kho số chung",
          path: "product/sim-public",
          icon: CiCreditCard1,
          componentName: "SimPublic",
          supplierCode: "SimPublic",
        },
        {
          name: "Kho số riêng",
          path: "product/sim-private",
          icon: CiCreditCard1,
          componentName: "SimPrivate",
          supplierCode: "SimPrivate",
        },
        {
          name: "Kho số đẹp",
          path: "product/sim-premium",
          icon: CiCreditCard1,
          componentName: "SimPremium",
          supplierCode: "SimPremium",
        },
        {
          name: "Quản lý phôi sim",
          path: "product/embryo",
          componentName: "SimEmbryo",
          serviceCode: "SimEmbryo",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Quản lý gói cước",
          path: "product/package",
          icon: BiBox,
          componentName: "PackegeMr",
          supplierCode: "PackegeMr",
        },
        {
          name: "Quản lý TOPUP AIRTIME",
          path: "product/topup",
          icon: BiBox,
          componentName: "TopupPage",
          supplierCode: "TopupPage",
        },
        {
          name: "Quản lý DATA",
          path: "product/data",
          icon: BiBox,
          componentName: "DataPage",
          supplierCode: "DataPage",
        },
        {
          name: "Quản lý Mã thẻ",
          path: "product/card",
          icon: BiBox,
          componentName: "CardPage",
          supplierCode: "CardPage",
        },
      ],
    },
    {
      name: "QUẢN LÝ HOA HỒNG",
      path: "manage-commissions",
      icon: FaMoneyCheck,
      componentName: "RosePage",
      supplierCode: "RosePage",
    },
    {
      name: "QUẢN LÝ KHÁCH HÀNG",
      path: "customer",
      icon: FaRegCircleUser,
      componentName: "ClientPage",
      supplierCode: "ClientPage",
    },
    {
      name: "QUẢN LÝ TÀI KHOẢN",
      path: "account",
      icon: IoSettingsOutline,
      componentName: "",
      supplierCode: "UserManagement",
      subMenu: [
        {
          name: "Tài khoản hệ thống",
          path: "account/system",
          icon: MdOutlineCreditCard,
          componentName: "UserManagementPage",
          supplierCode: "UserManagementPage",
        },
        {
          name: "Tài khoản quản lý vùng",
          path: "account/admin_merchant",
          icon: MdOutlineCreditCard,
          componentName: "AdminMerPage",
          supplierCode: "AdminMerPage",
        },
        {
          name: "Tài khoản đại lý",
          path: "account/merchant",
          icon: MdOutlineCreditCard,
          componentName: "MrPage",
          supplierCode: "MrPage",
        },
      ],
    },
    {
      name: "TÍNH NĂNG BẢO TRÌ",
      path: "manage-maintenance",
      icon: LuScrollText,
      componentName: "MaintenancePage",
      supplierCode: "MaintenancePage",
    },
  ],
  message: "Get menuPerApp successfully",
};

export const MER_CONFIG = {
  code: 0,
  data: [
    {
      name: "TỔNG QUAN",
      path: "dashboard",
      icon: MdOutlineSpaceDashboard,
      componentName: "DashBoardPage",
      supplierCode: "DashBoardPage",
    },
    {
      name: "QUẢN LÝ ĐƠN HÀNG",
      path: "order",
      icon: BsBox,
      componentName: "",
      supplierCode: "OrderPage",
      subMenu: [
        {
          name: "Đăng ký thuê bao",
          path: "order/dkttb",
          componentName: "DKTTB",
          serviceCode: "dkttb",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Chọn giữ số",
          path: "order/keep-number",
          componentName: "KeepNumber",
          serviceCode: "KeepNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        // {
        //   name: "Đơn hàng số đẹp",
        //   path: "order/premium-number",
        //   componentName: "PremiumNumber",
        //   serviceCode: "PremiumNumber",
        //   icon: GrTransaction,
        //   subMenu: [],
        // },
        {
          name: "Đơn hàng Topup",
          path: "order/topup",
          componentName: "TopupOrder",
          serviceCode: "topup",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Data",
          path: "order/data",
          componentName: "DataOrder",
          serviceCode: "data",
          icon: GrTransaction,
          subMenu: [],
        },
      ],
    },
    {
      name: "QUẢN LÝ GIAO DỊCH",
      path: "transaction",
      icon: LuScrollText,
      componentName: "TransactionMer",
      supplierCode: "TransactionMer",
    },

    {
      name: "QUẢN LÝ HẠN MỨC",
      path: "wallet",
      icon: IoCardOutline,
      componentName: "LimitPage",
      supplierCode: "limit",
    },
    {
      name: "LỊCH SỬ DÒNG TIỀN",
      path: "history",
      icon: LuHistory,
      componentName: "Transaction",
      supplierCode: "history",
    },
    {
      name: "QUẢN LÝ SẢN PHẨM",
      path: "product",
      icon: BsBox2,
      componentName: "",
      supplierCode: "product",
      subMenu: [
        {
          name: "Kho số chung",
          path: "product/sim-public",
          icon: CiCreditCard1,
          componentName: "SimPublic",
          supplierCode: "SimPublic",
        },
        {
          name: "Kho số riêng",
          path: "product/sim-private",
          icon: CiCreditCard1,
          componentName: "SimPrivate",
          supplierCode: "SimPrivate",
        },
        {
          name: "Quản lý phôi sim",
          path: "product/embryo",
          componentName: "SimEmbryo",
          serviceCode: "SimEmbryo",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Quản lý gói cước",
          path: "product/packege",
          icon: BiBox,
          componentName: "PackegeMr",
          supplierCode: "PackegeMr",
        },
      ],
    },
    {
      name: "QUẢN LÝ HOA HỒNG",
      path: "manage-commissions",
      icon: FaMoneyCheck,
      componentName: "RosePage",
      supplierCode: "RosePage",
    },
    {
      name: "QUẢN LÝ KHÁCH HÀNG",
      path: "customer",
      icon: FaRegCircleUser,
      componentName: "ClientPage",
      supplierCode: "ClientPage",
    },
    {
      name: "QUẢN LÝ TÀI KHOẢN",
      path: "account",
      icon: IoSettingsOutline,
      componentName: "",
      supplierCode: "UserManagement",
      subMenu: [
        {
          name: "Tài khoản đại lý",
          path: "account/merchant",
          icon: MdOutlineCreditCard,
          componentName: "MrPage",
          supplierCode: "MrPage",
        },
      ],
    },
  ],
  message: "Get menuPerApp successfully",
};

export const SALE_CONFIG = {
  code: 0,
  data: [
    {
      name: "TỔNG QUAN",
      path: "dashboard",
      icon: MdOutlineSpaceDashboard,
      componentName: "DashBoardPage",
      supplierCode: "DashBoardPage",
    },
    {
      name: "QUẢN LÝ ĐƠN HÀNG",
      path: "order",
      icon: BsBox,
      componentName: "",
      supplierCode: "OrderPage",
      subMenu: [
        {
          name: "Đăng ký thuê bao",
          path: "order/dkttb",
          componentName: "DKTTB",
          serviceCode: "dkttb",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Chọn giữ số",
          path: "order/keep-number",
          componentName: "KeepNumber",
          serviceCode: "KeepNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng số đẹp",
          path: "order/premium-number",
          componentName: "PremiumNumber",
          serviceCode: "PremiumNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Topup",
          path: "order/topup",
          componentName: "TopupOrder",
          serviceCode: "topup",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Data",
          path: "order/data",
          componentName: "DataOrder",
          serviceCode: "data",
          icon: GrTransaction,
          subMenu: [],
        },
      ],
    },
    {
      name: "QUẢN LÝ GIAO DỊCH",
      path: "transaction",
      icon: LuScrollText,
      componentName: "TransactionMer",
      supplierCode: "TransactionMer",
    },

    {
      name: "QUẢN LÝ HẠN MỨC",
      path: "wallet",
      icon: IoCardOutline,
      componentName: "LimitPage",
      supplierCode: "limit",
    },
    {
      name: "LỊCH SỬ DÒNG TIỀN",
      path: "history",
      icon: LuHistory,
      componentName: "Transaction",
      supplierCode: "history",
    },
    {
      name: "QUẢN LÝ SẢN PHẨM",
      path: "product",
      icon: BsBox2,
      componentName: "",
      supplierCode: "product",
      subMenu: [
        {
          name: "Kho số chung",
          path: "product/sim-public",
          icon: CiCreditCard1,
          componentName: "SimPublic",
          supplierCode: "SimPublic",
        },
        {
          name: "Kho số riêng",
          path: "product/sim-private",
          icon: CiCreditCard1,
          componentName: "SimPrivate",
          supplierCode: "SimPrivate",
        },
        {
          name: "Quản lý phôi sim",
          path: "product/embryo",
          componentName: "SimEmbryo",
          serviceCode: "SimEmbryo",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Quản lý gói cước",
          path: "product/packege",
          icon: BiBox,
          componentName: "PackegeMr",
          supplierCode: "PackegeMr",
        },
      ],
    },
    {
      name: "QUẢN LÝ KHÁCH HÀNG",
      path: "customer",
      icon: FaRegCircleUser,
      componentName: "ClientPage",
      supplierCode: "ClientPage",
    },
  ],
  message: "Get menuPerApp successfully",
};

export const AGENCY_CONFIG = {
  code: 0,
  data: [
    {
      name: "QUẢN LÝ ĐƠN HÀNG",
      path: "order",
      icon: BsBox,
      componentName: "",
      supplierCode: "OrderPage",
      subMenu: [
        {
          name: "Đăng ký thuê bao",
          path: "order/dkttb",
          componentName: "DKTTB",
          serviceCode: "dkttb",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Chọn giữ số",
          path: "order/keep-number",
          componentName: "KeepNumber",
          serviceCode: "KeepNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        // {
        //   name: "Đơn hàng Gán gói",
        //   path: "order/addPackage",
        //   componentName: "AddPackage",
        //   serviceCode: "addPackage",
        //   icon: GrTransaction,
        //   subMenu: [],
        // },
        {
          name: "Đơn hàng Topup",
          path: "order/topup",
          componentName: "TopupOrder",
          serviceCode: "topup",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Data",
          path: "order/data",
          componentName: "DataOrder",
          serviceCode: "data",
          icon: GrTransaction,
          subMenu: [],
        },
      ],
    },
    {
      name: "QUẢN LÝ GIAO DỊCH",
      path: "transaction",
      icon: LuScrollText,
      componentName: "TransactionMer",
      supplierCode: "TransactionMer",
    },
    {
      name: "QUẢN LÝ HẠN MỨC",
      path: "wallet",
      icon: IoCardOutline,
      componentName: "LimitPage",
      supplierCode: "limit",
    },
    {
      name: "LỊCH SỬ DÒNG TIỀN",
      path: "history",
      icon: LuHistory,
      componentName: "Transaction",
      supplierCode: "history",
    },
    {
      name: "QUẢN LÝ SẢN PHẨM",
      path: "product",
      icon: BsBox2,
      componentName: "",
      supplierCode: "product",
      subMenu: [
        {
          name: "Kho số chung",
          path: "product/sim-public",
          icon: CiCreditCard1,
          componentName: "SimPublic",
          supplierCode: "SimPublic",
        },
        {
          name: "Kho số riêng",
          path: "product/sim-private",
          icon: CiCreditCard1,
          componentName: "SimPrivate",
          supplierCode: "SimPrivate",
        },
        {
          name: "Quản lý phôi sim",
          path: "product/embryo",
          componentName: "SimEmbryo",
          serviceCode: "SimEmbryo",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Quản lý gói cước",
          path: "product/packege",
          icon: BiBox,
          componentName: "PackegeMr",
          supplierCode: "PackegeMr",
        },
      ],
    },
    {
      name: "QUẢN LÝ HOA HỒNG",
      path: "manage-commissions",
      icon: FaMoneyCheck,
      componentName: "RosePage",
      supplierCode: "RosePage",
    },
    {
      name: "QUẢN LÝ KHÁCH HÀNG",
      path: "customer",
      icon: FaRegCircleUser,
      componentName: "ClientPage",
      supplierCode: "ClientPage",
    },
  ],
  message: "Get menuPerApp successfully",
};

export const STAFF_CONFIG = {
  code: 0,
  data: [
    {
      name: "TỔNG QUAN",
      path: "dashboard",
      icon: MdOutlineSpaceDashboard,
      componentName: "DashBoardPage",
      supplierCode: "DashBoardPage",
    },
    {
      name: "QUẢN LÝ ĐƠN HÀNG",
      path: "order",
      icon: BsBox,
      componentName: "",
      supplierCode: "OrderPage",
      subMenu: [
        {
          name: "Đăng ký thuê bao",
          path: "order/dkttb",
          componentName: "DKTTB",
          serviceCode: "dkttb",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Chọn giữ số",
          path: "order/keep-number",
          componentName: "KeepNumber",
          serviceCode: "KeepNumber",
          icon: GrTransaction,
          subMenu: [],
        },
        // {
        //   name: "Đơn hàng Gán gói",
        //   path: "order/addPackage",
        //   componentName: "AddPackage",
        //   serviceCode: "addPackage",
        //   icon: GrTransaction,
        //   subMenu: [],
        // },
        {
          name: "Đơn hàng Topup",
          path: "order/topup",
          componentName: "TopupOrder",
          serviceCode: "topup",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Đơn hàng Data",
          path: "order/data",
          componentName: "DataOrder",
          serviceCode: "data",
          icon: GrTransaction,
          subMenu: [],
        },
      ],
    },
    {
      name: "QUẢN LÝ GIAO DỊCH",
      path: "transaction",
      icon: LuScrollText,
      componentName: "TransactionMer",
      supplierCode: "TransactionMer",
    },
    {
      name: "QUẢN LÝ HẠN MỨC",
      path: "wallet",
      icon: IoCardOutline,
      componentName: "LimitPage",
      supplierCode: "limit",
    },
    {
      name: "LỊCH SỬ DÒNG TIỀN",
      path: "history",
      icon: LuHistory,
      componentName: "Transaction",
      supplierCode: "history",
    },
    {
      name: "QUẢN LÝ SẢN PHẨM",
      path: "product",
      icon: BsBox2,
      componentName: "",
      supplierCode: "product",
      subMenu: [
        {
          name: "Kho số chung",
          path: "product/sim-public",
          icon: CiCreditCard1,
          componentName: "SimPublic",
          supplierCode: "SimPublic",
        },
        {
          name: "Kho số riêng",
          path: "product/sim-private",
          icon: CiCreditCard1,
          componentName: "SimPrivate",
          supplierCode: "SimPrivate",
        },
        {
          name: "Quản lý phôi sim",
          path: "product/embryo",
          componentName: "SimEmbryo",
          serviceCode: "SimEmbryo",
          icon: GrTransaction,
          subMenu: [],
        },
        {
          name: "Quản lý gói cước",
          path: "product/packege",
          icon: BiBox,
          componentName: "PackegeMr",
          supplierCode: "PackegeMr",
        },
      ],
    },
    {
      name: "QUẢN LÝ HOA HỒNG",
      path: "manage-commissions",
      icon: FaMoneyCheck,
      componentName: "RosePage",
      supplierCode: "RosePage",
    },
    {
      name: "QUẢN LÝ KHÁCH HÀNG",
      path: "customer",
      icon: FaRegCircleUser,
      componentName: "ClientPage",
      supplierCode: "ClientPage",
    },
  ],
  message: "Get menuPerApp successfully",
};
